export default __webpack_public_path__ + "static/media/greeni-4.f9c66b53.jpg";